export const onEnterPress = (e: React.KeyboardEvent<HTMLElement>, callback: () => void) => {
  if (e.key === 'Enter' || e.key === ' ') {
    callback();
  }
};
